import { ArtistProfileScreen } from "@components/Account/Profile/ArtistProfileScreen";

export default ArtistProfileScreen;
